//
// vendor modules
import { connect } from "react-redux"

// shared modules
import {
    selectHasRelatedActiveFilters,
    selectIsFilterGroupOpen,
    selectPermissionedFilterComponents,
} from "shared/search/selectors"

import { openFilterGroup, toggleFilterGroup } from "shared/search/action-creators"

// components
import FilterGroup from "shared/search/components/FilterGroup/index"

const mapStateToProps = (state, props) => ({
    hasActiveFilter: selectHasRelatedActiveFilters(state, props),
    isOpen: selectIsFilterGroupOpen(state, props),
    permissionedFilters: selectPermissionedFilterComponents(state, props),
})

export default connect(mapStateToProps, {
    openFilterGroup,
    toggleFilterGroup,
})(FilterGroup)
